import type { TFunction } from "i18next";
import { ContentKind } from "reedy-data/models";

export const kindLabel = (
  t: TFunction<["productDetails"]>,
  kind: ContentKind,
): string => {
  switch (kind) {
    case ContentKind.KEYWORDS:
      return t("productDetails:salesData.events.kinds.keywords");
    case ContentKind.THEMA_CODES:
      return t("productDetails:salesData.events.kinds.themaCodes");
    case ContentKind.DESCRIPTION:
      return t("productDetails:salesData.events.kinds.description");
    default:
      return kind;
  }
};
